/**
 * Convert an Axios upload ProgressEvent to a 0–100 integer, or null when total is unknown.
 * @param {{ loaded?: number, total?: number, lengthComputable?: boolean }|null|undefined} event
 * @returns {number|null}
 */
export function percentFromAxiosProgress(event) {
    if (!event || event.lengthComputable === false) {
        return null;
    }
    const total = Number(event.total);
    if (!Number.isFinite(total) || total <= 0) {
        return null;
    }
    const loaded = Number(event.loaded);
    if (!Number.isFinite(loaded) || loaded < 0) {
        return 0;
    }
    return Math.min(100, Math.max(0, Math.round((loaded / total) * 100)));
}

/**
 * Adapter for Integration `onProgress({ percent, loaded, total, phase })`.
 * Phase is `processing` once the request body is fully sent (percent === 100).
 * @param {Function|undefined} onProgress
 * @returns {Function|undefined}
 */
export function toUploadProgressHandler(onProgress) {
    if (typeof onProgress !== 'function') {
        return undefined;
    }
    return (event) => {
        const percent = percentFromAxiosProgress(event);
        const loaded = Number(event?.loaded);
        const total = Number(event?.total);
        onProgress({
            percent,
            loaded: Number.isFinite(loaded) ? loaded : 0,
            total: Number.isFinite(total) && total > 0 ? total : null,
            phase: percent === 100 ? 'processing' : 'uploading',
        });
    };
}
